import { render, staticRenderFns } from "./PCCourse.vue?vue&type=template&id=9ff8dd40&"
import script from "./PCCourse.vue?vue&type=script&lang=js&"
export * from "./PCCourse.vue?vue&type=script&lang=js&"
import style0 from "./PCCourse.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports